"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _flyout = _interopRequireDefault(require("@ux/flyout"));
var _flip = _interopRequireDefault(require("@ux/flyout/middleware/flip"));
var _space = _interopRequireWildcard(require("@ux/space"));
var _classnames = _interopRequireDefault(require("classnames"));
const _excluded = ["anchorRef", "children", "className", "open", "middleware"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UX_TOOLTIP_CLASSNAME = 'ux-tooltip';

/**
 * Create a Tooltip
 *
 * @param {Object} props - Component properties
 * @param {Ref} anchorRef - The ref to attach the tooltip
 * @param {String} [props.className] - Provides an optional class name to be set on the root
 * @param {Node} [props.children] - Children
 * @param {Boolean} [props.open] - If content is set within the tooltip, this controls visibility
 * @returns {Component} - Tooltip
 */
function Tooltip(_ref) {
  let {
      anchorRef,
      children,
      className,
      open = true,
      middleware = []
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  delete rest.style;
  if (!anchorRef) return null;
  const flyout = /*#__PURE__*/_react.default.createElement(_flyout.default, (0, _extends2.default)({
    anchorRef: anchorRef,
    className: (0, _classnames.default)(UX_TOOLTIP_CLASSNAME, className),
    placement: "top",
    arrow: true,
    middleware: [(0, _flip.default)(), ...middleware],
    role: "tooltip"
  }, rest), /*#__PURE__*/_react.default.createElement(_space.default.div, {
    className: `${UX_TOOLTIP_CLASSNAME}-content`,
    "data-version": "2400",
    inline: _space.sizeOptions.MD,
    block: _space.sizeOptions.MD
  }, children));
  return open && children && flyout;
}
Tooltip.propTypes = {
  /** Reference to a DOM element where the flyout should be visually attached. The flyout will not render without this */
  anchorRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.object
  })]),
  /** Determines if an arrow should be included on the flyout, if a string is provided, set the size of the arrow */
  arrow: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /** Children to render within the flyout */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  /** Id for the flyout, used for accessibility */
  id: _propTypes.default.string,
  /** Placement, for more details see https://floating-ui.com/ */
  placement: _flyout.default.propTypes.placement,
  /** Sets the strategy for @floating-ui (absolute/fixed) */
  strategy: _propTypes.default.oneOf(['absolute', 'fixed']),
  /** Role for the flyout, used for accessibility */
  role: _propTypes.default.string,
  /** Fires when the user attempts to escape from the flyout */
  onClose: _propTypes.default.func,
  /** Fires when the flyout position changes */
  onPlacement: _propTypes.default.func,
  /** Stretches the flyout to the nearest relative ancestor */
  stretch: _propTypes.default.bool,
  /** Optional class name for positioning */
  className: _propTypes.default.string,
  /** Optional releact element to create a react portal from  */
  portalElem: _propTypes.default.object,
  /** If content is set within the tooltip, this controls visibility */
  open: _propTypes.default.bool,
  /** Middleware for customizing behavior and positioning (passed down to flyout), see https://floating-ui.com/docs/middleware */
  middleware: _propTypes.default.arrayOf(_propTypes.default.object)
};
Tooltip.displayName = 'Tooltip';
var _default = exports.default = Tooltip;